import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.EVENTS].GET_EVENTS]: {
		url: '/company/:companyId/events/',
	},

	[ModulesConfigMap[ModulesMap.EVENTS].GET_EVENT]: {
		url: '/company/:companyId/events/:eventId/',
	},

	[ModulesConfigMap[ModulesMap.EVENTS].GET_EVENT_PREVIEW]: {
		url: '/company/:companyId/events/:eventId/preview/',
	},

	[ModulesConfigMap[ModulesMap.EVENTS].PATCH_EVENT]: {
		url: '/company/:companyId/events/:eventId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
}
